"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
window.site = window.site || {};

/**
 * Utilities for jQuery to Javascript Helper/Reminder
 * @class HelperReminder
 * @static
 */
site.HelperReminder = function HelperReminder($) {
  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initializes the class.
   * @public
   */
  var init = function init() {
    // Abort if already initialized
    if (inited) {
      return false;
    }
    inited = true;

    // var $myElement = $('#myElement');
    var $myElement = document.querySelector('#myElement');
    // var $navLinks = $('.nav-links');
    var $navLinks = document.querySelectorAll('.nav-links');
    // var $label = $myElement.find('p'); || var $label = $('p', $myElement);
    var $label = $myElement.querySelector('p');
    // var attr = $label.attr('data-my-attribute');
    var attr = $label.getAttribute('data-my-attribute');

    // $.each($navLinks, function(index, val) {
    //   var item = $(this);
    // });

    // $navLinks.on('click', function(event) {
    //   event.preventDefault();
    //   $label.text('Success!');
    //    [...]
    //   $myElement.addClass('is-active');
    // });
    $navLinks.forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        $label.textContent = 'Success!';
        $myElement.innerHTML += "\n          <div>\n            <p data-custom-attr=\"".concat(attr, "\" >My Html!</p>\n          </div>\n        ");
        $myElement.classList.add('is-active');
      });
    });
    ES6ThisPlease();
    return true;
  };
  var ES6ThisPlease = function ES6ThisPlease() {
    var nums = [1, 2, 3, 4, 5];
    nums.forEach(function (v) {
      return console.log(v);
    });

    // Food is a base class
    var Food = /*#__PURE__*/function () {
      function Food(name, protein, carbs, fat) {
        _classCallCheck(this, Food);
        this.name = name;
        this.protein = protein;
        this.carbs = carbs;
        this.fat = fat;
      }
      return _createClass(Food, [{
        key: "toString",
        value: function toString() {
          return "".concat(this.name, " | ").concat(this.protein, "g P :: ").concat(this.carbs, "g C :: ").concat(this.fat, "g F");
        }
      }, {
        key: "print",
        value: function print() {
          console.log(this.toString());
        }
      }]);
    }();
    var chicken_breast = new Food('Chicken Breast', 26, 0, 3.5);
    chicken_breast.print(); // 'Chicken Breast | 26g P :: 0g C :: 3.5g F'
    console.log(chicken_breast.protein); // 26 (LINE A)
  };

  // Expose public methods & properties
  return {
    init: init
  };
}();